import './completionTrackingActions';
import { trackedQuizActions } from './trackedQuizActions';

export type TrackedQuizState = {
  quizId: string | null;
  score: number | null;
  passed: boolean | null;
};

export function createTrackedQuizState(startState: TrackedQuizState) {
  return (state: TrackedQuizState = startState, action: any): TrackedQuizState => {
    switch (action.type) {
      case trackedQuizActions.Tracking_SubmitQuiz:
        if (action.payload.quizId === state.quizId) {
          // Do not update state if the score is not higher than the current score
          // TODO - is this the right logic?
          if (state.score !== null && state.score >= action.payload.score) {
            return state;
          }
          return { ...state, score: action.payload.score, passed: action.payload.score >= action.payload.passingScore };
        }
        return state;
      default:
        return state;
    }
  };
}
